<!--
component: ListAddress
author: Ken Nakamura
description: 住所検索結果リスト
-->
<template>
  <section>
    <v-data-table
      id="table"
      :headers="headers"
      :items="kenkaku"
      :fixed-header="false"
      mobile-breakpoint="0"
      height="calc(100vh - 20em)"
      disable-pagination hide-default-footer dense
      :single-select="true" item-key="daichoId"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, index) in items"
            @click="selectRow(item)"
            :id="item.daichoId"
            :key="index"
            class="default"
            :class="`enable-${item.enable}-selected-${item.active}`"
          >
            <!--:class="{selected:item.active}"-->
            <td>{{item.type}}</td>
            <td>{{item.ukeNo}}</td>
            <td>{{dateTextToWareki(item.ukeDay)}}</td>
            <td>{{item.addr}}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { dbglog, dateTextToWareki } from '../common/utils'

export default {
  data: () => {
    return {
      headers: [
        {
          text: '物件種別',
          value: 'type'
        },
        {
          text: '受付番号',
          value: 'ukeNo'
        },
        {
          text: '受付日',
          value: 'ukeDay'
        },
        {
          text: '地名地番',
          value: 'addr'
        },
      ],
    }
  },
  props: {
  },
  mounted () {
    this.scrollToSelection();
  },
  computed: {
    kenkaku () {
      return this.$store.state.summaries;
      //return this.$store.state.gaiyoList;
    },
  },
  methods: {
    /**
     * 日付の和暦変換
     * @param {Date} date 変換する日付
     * @return {String} 和暦表現に変換された文字列を返す
     */
    dateTextToWareki(date) {
      return dateTextToWareki(date);  // from utils.js
    },
    /**
     * 一覧でクリックされた行を選択
     * @param {GaiyoSummary} target 選択する概要データ
     */
    selectRow (target) {
      dbglog(`ListAddress.selectRow(${target.daichoId})`);
      this.$store.commit('setGaiyoId', target.daichoId);
      this.$store.commit('setKojiId', target.kojiId);
      this.$store.commit('setUkeDay', target.ukeDay);
      this.$store.commit('setUkeNo', target.ukeNo);
      this.kenkaku.forEach((k) => {
        k.active = (k === target);
      });
      //test
      this.$store.commit('setGaiyoEnabled', target.enable);
      const className = `enable-${target.enable}-selected-${target.active}`;
      dbglog(className);
    },
    /**
     * 選択されている物件がリスト中央に表示されるようにスクロールする
     */
    scrollToSelection () {
      try {
        if (this.$store.state.gaiyoId) {
          const tr = document.getElementById(this.$store.state.gaiyoId);
          //behaviorを指定すると建築PC（Edgeの古いバージョン？）で動かなかった
          //tr.scrollIntoView({ behavior: 'smooth', block: 'center' });
          tr.scrollIntoView({ block: 'center' });
        }
      }
      catch (err) {
        console.log('scrollToSelection error: ' + err);
      }
    }
  },  
}
</script>
<style scoped src="@/styles/table-styles.css">
</style>